var CONCIERGE_MEMBERS = [
    {
        label: 'まるなげ',
        value: 'marunage',
    },
    {
        label: '直予約',
        value: 'yoyaku',
    },
    {
        label: '一括問い合わせ',
        value: 'bulk_yoyaku',
    },
    {
        label: 'Dランク',
        value: 'd_rank',
    }
];

var SHOP_TAGS = [
    // 利用シーン
    '接待',
    '大人数の宴会',
    '貸切宴会',
    '貸切パーティー',
    '立食パーティー',
    '懇親会・パーティー',
    '忘年会・新年会',
    '歓迎会・送別会',
    '企業パーティー',
    '謝恩会',
    '同窓会',
    '二次会',

    // 営業費・時間
    '夜10時以降入店可',
    '夜12時以降入店可',
    '始発まで営業',
    '日曜営業あり',

    // 空間・設備
    '個室',
    'オシャレな空間',
    '座敷',
    'カウンター席',
    'ソファー席',
    '落ち着いた空間',
    '掘りごたつ',
    'オープンテラス',
    'ライブ・生演奏',

    // ロケーション
    '駅近',
    '最寄り駅から徒歩3分',
    '最寄り駅から徒歩5分',
    '最寄り駅から徒歩7分',
    '最寄り駅から徒歩10分',

    // 料理・ドリンク
    '飲み放題',
    '食べ放題',
    'ワインあり',
    '日本酒あり',
    'カクテルあり',
    '焼酎あり',
    '野菜料理にこだわる',
    '魚料理にこだわる',

    // サービス
    'カード可',
    'ペット可',
    'クーポン',
    '貸切可',
    '3時間以上の飲み放題コース',
    '予約可',
    'ネット予約可',
    'ドリンク持込可',
    'お祝い・サプライズ可',

    // コースで選ぶ
    '2000円台飲み放題コース',
    '3000円台飲み放題コース',
    '4000円台飲み放題コース',
    '3時間以上OKのコース',

    // コースから探す・予約する
    '2000円台の飲み放題付コース',
    '3000円台の飲み放題付コース',
    '4000円台の飲み放題付コース',
    '5000円台の飲み放題付コース',
    '6000円台の飲み放題付コース',
    '7000円台の飲み放題付コース',
    '8000円台の飲み放題付コース',
    '9000円台の飲み放題付コース',
    '10000円以上の飲み放題付コース',
    '3時間以上のゆっくり宴会コース',

    // こだわり食材
    'こだわりのビールが飲めるお店',
    '焼酎・日本酒…お酒が豊富',
    '居酒屋',
    '創作料理',
    '和食',
    '中華',
    'アジア・エスニック料理',
    '各国料理',

    // 会場タイプ・特徴から探す・予約する
    '居酒屋',
    'レストラン・カフェ',
    'ホテル・宴会場',
    'ブライダル・パーティースペース',
    '座敷',
    '掘りごたつ',
    'テラス席・オープンテラス',
    'バリアフリー',
    '最寄り駅から徒歩5分以内',
    '分煙・喫煙スペース',
    '喫煙可能',
    '全面禁煙',

    // 設備から探す・予約する
    'マイク設備',
    'プロジェクター',
    'スクリーン',
    '請求書支払い可',
    'カラオケ、ダーツ、ゴルフなどが楽しめる',
    '音響設備',
    'ステージ',
    '楽器演奏可',
    '照明設備',

    // 料理ジャンルから探す・予約する
    'イタリアン',
    'フレンチ',
    '中華',
    '和食',
    'アジア・エスニック料理',
    'ハワイアン料理',
    '創作料理',
    '鍋',
    'スペイン料理',
    '居酒屋',
    '焼肉',
    'ダイニングバー',
    'カフェ',
    'ベジタリアン・ハラール・ビーガン対応可',

    // 貸切・個室から探す・予約する
    '20人以上で個室・貸切ができる',
    '30人以上で個室・貸切ができる',
    '40人以上で個室・貸切ができる',
    '50人以上で個室・貸切ができる',
    '60人以上で個室・貸切ができる',
    '70人以上で個室・貸切ができる',
    '80人以上で個室・貸切ができる',
    '90人以上で個室・貸切ができる',
    '100人以上で個室・貸切ができる',
    '150人以上で個室・貸切ができる',
    '200人以上で個室・貸切ができる',
    '300人以上で個室・貸切ができる',
    '500人以上1000人まで個室・貸切ができる',

    // 目的・利用シーンから探す・予約する
    '接待',
    '周年記念',
    'キックオフ',
    '表彰式・パーティー',
    '内定式・入社式',
    '記念式典',
    '展示会',
    '昼宴会・パーティー',
    '祝賀会・記念式典',
    '偲ぶ会・法要',
    '学生さん歓迎',
    '女子会・ママ会',
    '小さなお子様歓迎',
    'ランチ会・パーティー',
    '桜が見える',
    'クルージング',
    'エンターテイメントが楽しめる（ショー、バンド、ダンスなど）',

    // 会場タイプ・特徴から探す・予約する
    'イベントホール・会議室',
    'ユニークベニュー（船・その他）',
    'ワンフロア',
    'インバウンド・外国人に喜ばれる',
    '夜景が見える（窓）',
    'ラグジュアリー',
    '持ち込みOK',

    // 設備から探す・予約する
    '設備が無料で使える',
    'クレジットカード・キャッシュレス支払い可',
    '利用規約・キャンセルポリシーが明記',
    'DJブース',
    'ピアノ',
    'ライブ・ショー鑑賞',
    'スポーツ観戦',
    '控室・クローク',
    'ケーキ',
    'デザートプレート',
    '花束・景品手配',
    'キッズメニュー',
    'チャイルドシート',
    'プレイルーム',
    'ホワイトボード', 
    '演台', 
    'Wi-Fi',

    // 料理ジャンルから探す・予約する
    '魚料理が美味しい（自慢）',
    '肉料理が美味しい（自慢）',
    '大皿提供可能',
    '一皿提供可能',
    'ビュッフェ形式',
    '飲み放題の種類が豊富',
    '飲み放題に日本酒がある・種類が豊富',
    'ミシュラン実績あり',
    '英語メニュー対応可能',

    'ケータリング',
    'デリバリー',
    '23区内（ケータリング対応可）',
    '東京全域（ケータリング対応可）',
    '神奈川（ケータリング対応可）',
    '埼玉（ケータリング対応可）',
    '千葉（ケータリング対応可）',
];

var SHOP_SCENES = [
    'パーティー・懇親会',
    '忘年会・新年会',
    '歓迎会・送別会',
    '内定式・入社式+パーティー',
    '同窓会',
    '卒業パーティー・謝恩会・追いコン',
    '結婚式二次会',

    '会議(説明会)+パーティー',
    '表彰式+パーティー',
    '祝賀会・記念式典+パーティー',
    'キックオフ+パーティー',
    '偲ぶ会・お別れの会・法要',
    '二次会',
    '会議',
    '研修・勉強会',
    'セミナー・説明会・講演会・学会',
    'ウェビナー・オンライン会議',
    '試験会場',
    '入社式・内定式・表彰式',
    'キックオフ',
    '株主総会',
    '記者会見',
    '大型イベント・展示会',
    '面接',
    'その他イベント利用',
];

var SHOP_FEATURES = [
    // 部屋
    '個室',
    '完全個室',
    '貸切',
    'フロア貸切',

    // 席タイプ
    '座敷',
    '掘りごたつ',
    'オープンテラス',
    '立食',
    '着席',

    // 設備
    'ライブ・生演奏',
    'カラオケ',
    'プロジェクター',
    'ステージ',
    'ワンフロア',
    'バリアフリー',
    '大人数'
];


var SHOP_AREA = [
    { value: '', label: '----- 東京エリア -----' },
    { value: 1, prefecture: 'tokyo', label: '東京駅・丸の内・日本橋'},
    { value: 2, prefecture: 'tokyo', label: '銀座・有楽町・築地' },
    { value: 3, prefecture: 'tokyo', label: 'お台場・豊洲・湾岸' },
    { value: 4, prefecture: 'tokyo', label: '新宿・代々木' },
    { value: 5, prefecture: 'tokyo', label: '渋谷・原宿・青山・表参道' },
    { value: 6, prefecture: 'tokyo', label: '新橋・浜松町・田町' },
    { value: 7, prefecture: 'tokyo', label: '赤坂・六本木・麻布' },
    { value: 8, prefecture: 'tokyo', label: '品川・五反田・大崎' },
    { value: 9, prefecture: 'tokyo', label: '恵比寿・目黒・代官山' },
    { value: 10, prefecture: 'tokyo', label: '池袋・大塚・巣鴨・練馬' },
    { value: 11, prefecture: 'tokyo', label: '上野・浅草・北千住・綾瀬・亀有' },
    { value: 12, prefecture: 'tokyo', label: '飯田橋・四ツ谷・神楽坂' },
    { value: 13, prefecture: 'tokyo', label: '神田・秋葉原・水道橋' },
    { value: 14, prefecture: 'tokyo', label: '錦糸町・亀戸・新小岩' },
    { value: 15, prefecture: 'tokyo', label: '人形町・門前仲町・葛西' },
    { value: 16, prefecture: 'tokyo', label: '大井町・大森・蒲田' },
    { value: 17, prefecture: 'tokyo', label: '大久保・高田馬場' },
    { value: 18, prefecture: 'tokyo', label: '中野・吉祥寺・三鷹' },
    { value: 19, prefecture: 'tokyo', label: '下北沢・明大前・成城学園前' },
    { value: 20, prefecture: 'tokyo', label: '自由が丘・三軒茶屋・二子玉川' },
    { value: 21, prefecture: 'tokyo', label: '王子・赤羽・板橋' },
    { value: 22, prefecture: 'tokyo', label: '立川・八王子・国立・国分寺' },
    { value: 23, prefecture: 'tokyo', label: '府中・調布' },
    { value: 24, prefecture: 'tokyo', label: '町田・多摩' },
    { value: 30, prefecture: 'tokyo', label: 'その他東京' },
    { value: '', label: '----- 神奈川エリア -----' },
    { value: 25, prefecture: 'kanagawa', label: '横浜・みなとみらい' },
    { value: 31, prefecture: 'kanagawa', label: '川崎・鶴見' },
    { value: 32, prefecture: 'kanagawa', label: '桜木町・関内・元町・中華街' },
    { value: 33, prefecture: 'kanagawa', label: '新横浜・センター南' },
    { value: 34, prefecture: 'kanagawa', label: '武蔵小杉・日吉・綱島' },
    { value: 35, prefecture: 'kanagawa', label: '溝の口・たまプラーザ・青葉台・長津田' },
    //{ value: 36, prefecture: 'kanagawa', label: '登戸・新百合ヶ丘' },
    { value: 37, prefecture: 'kanagawa', label: '厚木・海老名・大和・相模大野・中央林間' },
    //{ value: 38, prefecture: 'kanagawa', label: '保土ヶ谷・戸塚・上大岡・磯子・金沢文庫' },
    //{ value: 39, prefecture: 'kanagawa', label: '横須賀・三浦半島・逗子・葉山' },
    //{ value: 40, prefecture: 'kanagawa', label: '大船・鎌倉' },
    { value: 41, prefecture: 'kanagawa', label: '藤沢・茅ヶ崎・平塚' },
    //{ value: 42, prefecture: 'kanagawa', label: '小田原・箱根・湯河原' },
    { value: 53, prefecture: 'kanagawa', label: 'その他神奈川' },
    { value: '', label: '----- 千葉エリア -----' },
    { value: 26, prefecture: 'chiba', label: '千葉・幕張・稲毛' },
    { value: 43, prefecture: 'chiba', label: '船橋・津田沼・市川' },
    { value: 44, prefecture: 'chiba', label: '舞浜・浦安・行徳' },
    { value: 45, prefecture: 'chiba', label: '柏・松戸・我孫子' },
    //{ value: 46, prefecture: 'chiba', label: '成田・八千代・鎌ヶ谷' },
    //{ value: 47, prefecture: 'chiba', label: '市原・木更津・房総・銚子' },
    { value: 54, prefecture: 'chiba', label: 'その他千葉' },
    { value: '', label: '----- 埼玉エリア -----' },
    { value: 27, prefecture: 'saitama', label: '大宮・さいたま新都心' },
    { value: 48, prefecture: 'saitama', label: '浦和' },
    //{ value: 49, prefecture: 'saitama', label: '川口・越谷・草加・春日部' },
    //{ value: 50, prefecture: 'saitama', label: '川越・和光・朝霞・志木' },
    //{ value: 51, prefecture: 'saitama', label: '所沢・入間・飯能・秩父' },
    //{ value: 52, prefecture: 'saitama', label: '上尾・久喜・熊谷・桶川' },
    { value: 55, prefecture: 'saitama', label: 'その他埼玉' },

    { value: '', label: '----- 大阪エリア -----' },
    { value: 100, prefecture: 'osaka', label: '大阪' },
    { value: '', label: '----- 愛知エリア -----' },
    { value: 200, prefecture: 'aichi', label: '愛知' },
    { value: '', label: '----- その他 -----' },
    { value: 99999, prefecture: 'sonota', label: 'その他' },
];

var MARUNAGE_SHOP_AREA = _.clone(SHOP_AREA);
var areaValues = _.map(MARUNAGE_SHOP_AREA, 'value');
var tokyoAreaIndex = _.indexOf(areaValues, '');
MARUNAGE_SHOP_AREA.splice(tokyoAreaIndex+1, 0, { value: 1001, label: '東京全域' });
areaValues = _.map(MARUNAGE_SHOP_AREA, 'value');
var kanagawaAreaIndex = _.indexOf(areaValues, '', tokyoAreaIndex+1);
MARUNAGE_SHOP_AREA.splice(kanagawaAreaIndex+1, 0, { value: 1002, label: '神奈川全域' });
areaValues = _.map(MARUNAGE_SHOP_AREA, 'value');
var chibaAreaIndex = _.indexOf(areaValues, '', kanagawaAreaIndex+1);
MARUNAGE_SHOP_AREA.splice(chibaAreaIndex+1, 0, { value: 1003, label: '千葉全域' });
areaValues = _.map(MARUNAGE_SHOP_AREA, 'value');
var saitamaAreaIndex = _.indexOf(areaValues, '', chibaAreaIndex+1);
MARUNAGE_SHOP_AREA.splice(saitamaAreaIndex+1, 0, { value: 1004, label: '埼玉全域' });

var MARUNAGE_SHOP_PREFECTURE = [
    { value: '', label: '----北海道・東北エリア----' },
    { value: 'hokkaido', label: '北海道' },
    { value: 'aomori', label: '青森県' },
    { value: 'iwate', label: '岩手県' },
    { value: 'miyagi', label: '宮城県' },
    { value: 'akita', label: '秋田県' },
    { value: 'yamagata', label: '山形県' },
    { value: 'fukushima', label: '福島県' },
    { value: '', label: '----関東エリア----' },
    { value: 'ibaraki', label: '茨城県' },
    { value: 'tochigi', label: '栃木県' },
    { value: 'gunma', label: '群馬県' },
    { value: 'saitama', label: '埼玉県' },
    { value: 'chiba', label: '千葉県' },
    { value: 'tokyo', label: '東京都' },
    { value: 'kanagawa', label: '神奈川県' },
    { value: '', label: '----北陸・東海エリア----' },
    { value: 'niigata', label: '新潟県' },
    { value: 'toyama', label: '富山県' },
    { value: 'ishikawa', label: '石川県' },
    { value: 'fukui', label: '福井県' },
    { value: 'yamanashi', label: '山梨県' },
    { value: 'nagano', label: '長野県' },
    { value: 'gifu', label: '岐阜県' },
    { value: 'shizuoka', label: '静岡県' },
    { value: 'aichi', label: '愛知県' },
    { value: '', label: '----近畿エリア----' },
    { value: 'mie', label: '三重県' },
    { value: 'shiga', label: '滋賀県' },
    { value: 'kyoto', label: '京都府' },
    { value: 'osaka', label: '大阪府' },
    { value: 'hyogo', label: '兵庫県' },
    { value: 'nara', label: '奈良県' },
    { value: 'wakayama', label: '和歌山県' },
    { value: '', label: '----中国地方エリア----' },
    { value: 'tottori', label: '鳥取県' },
    { value: 'shimane', label: '島根県' },
    { value: 'okayama', label: '岡山県' },
    { value: 'hiroshima', label: '広島県' },
    { value: 'yamaguchi', label: '山口県' },
    { value: '', label: '----四国エリア----' },
    { value: 'tokushima', label: '徳島県' },
    { value: 'kagawa', label: '香川県' },
    { value: 'ehime', label: '愛媛県' },
    { value: 'kochi', label: '高知県' },
    { value: '', label: '----九州・沖縄エリア----' },
    { value: 'fukuoka', label: '福岡県' },
    { value: 'saga', label: '佐賀県' },
    { value: 'nagasaki', label: '長崎県' },
    { value: 'kumamoto', label: '熊本県' },
    { value: 'oita', label: '大分県' },
    { value: 'miyazaki', label: '宮崎県' },
    { value: 'kagoshima', label: '鹿児島県' },
    { value: 'okinawa', label: '沖縄県' },
];

var SHOP_AREA_DETAIL= [
    { value: 1, label: '東京駅', area: 1 },
    { value: 2, label: '丸の内', area: 1 },
    { value: 3, label: '日本橋', area: 1 },
    { value: 4, label: '銀座', area: 2 },
    { value: 5, label: '有楽町', area: 2 },
    { value: 6, label: '築地', area: 2 },
    { value: 7, label: 'お台場', area: 3 },
    { value: 8, label: '豊洲', area: 3 },
    { value: 9, label: '湾岸', area: 3 },
    { value: 10, label: '新宿', area: 4 },
    { value: 11, label: '代々木', area: 4 },
    { value: 12, label: '渋谷', area: 5 },
    { value: 13, label: '原宿', area: 5 },
    { value: 14, label: '青山', area: 5 },
    { value: 15, label: '表参道', area: 5 },
    { value: 16, label: '新橋', area: 6 },
    { value: 17, label: '浜松町', area: 6 },
    { value: 18, label: '田町', area: 6 },
    { value: 19, label: '赤坂', area: 7 },
    { value: 20, label: '六本木', area: 7 },
    { value: 21, label: '麻布', area: 7 },
    { value: 22, label: '品川', area: 8 },
    { value: 23, label: '五反田', area: 8 },
    { value: 24, label: '大崎', area: 8 },
    { value: 25, label: '恵比寿', area: 9 },
    { value: 26, label: '目黒', area: 9 },
    { value: 27, label: '代官山', area: 9 },
    { value: 28, label: '池袋', area: 10 },
    { value: 29, label: '大塚', area: 10 },
    { value: 30, label: '巣鴨', area: 10 },
    { value: 31, label: '練馬', area: 10 },
    { value: 32, label: '上野', area: 11 },
    { value: 33, label: '浅草', area: 11 },
    { value: 34, label: '北千住', area: 11 },
    { value: 35, label: '綾瀬', area: 11 },
    { value: 36, label: '亀有', area: 11 },
    { value: 37, label: '飯田橋', area: 12 },
    { value: 38, label: '四ツ谷', area: 12 },
    { value: 39, label: '神楽坂', area: 12 },
    { value: 40, label: '神田', area: 13 },
    { value: 41, label: '秋葉原', area: 13 },
    { value: 42, label: '水道橋', area: 13 },
    { value: 43, label: '錦糸町', area: 14 },
    { value: 44, label: '亀戸', area: 14 },
    { value: 45, label: '新小岩', area: 14 },
    { value: 46, label: '人形町', area: 15 },
    { value: 47, label: '門前仲町', area: 15 },
    { value: 48, label: '葛西', area: 15 },
    { value: 49, label: '大井町', area: 16 },
    { value: 50, label: '大森', area: 16 },
    { value: 51, label: '蒲田', area: 16 },
    { value: 52, label: '大久保', area: 17 },
    { value: 53, label: '高田馬場', area: 17 },
    { value: 54, label: '中野', area: 18 },
    { value: 55, label: '吉祥寺', area: 18 },
    { value: 56, label: '三鷹', area: 18 },
    { value: 57, label: '下北沢', area: 19 },
    { value: 58, label: '明大前', area: 19 },
    { value: 59, label: '成城学園前', area: 19 },
    { value: 60, label: '自由が丘', area: 20 },
    { value: 61, label: '三軒茶屋', area: 20 },
    { value: 62, label: '二子玉川', area: 20 },
    { value: 63, label: '王子', area: 21 },
    { value: 64, label: '赤羽', area: 21 },
    { value: 65, label: '板橋', area: 21 },
    { value: 66, label: '立川', area: 22 },
    { value: 67, label: '八王子', area: 22 },
    { value: 68, label: '国立', area: 22 },
    { value: 69, label: '国分寺', area: 22 },
    { value: 70, label: '府中', area: 23 },
    { value: 71, label: '調布', area: 23 },
    { value: 72, label: '町田', area: 24 },
    { value: 73, label: '多摩', area: 24 },

    { value: 74, label: '横浜', area: 25 },
    { value: 80, label: 'みなとみらい', area: 25 },
    { value: 75, label: '千葉', area: 26 },
    { value: 120, label: '幕張', area: 26 },
    { value: 121, label: '稲毛', area: 26 },
    { value: 76, label: '大宮', area: 27 },
    { value: 138, label: 'さいたま新都心', area: 27 },
    { value: 79, label: 'その他東京', area: 30 },
    { value: 81, label: '川崎', area: 31 },
    { value: 82, label: '鶴見', area: 31 },
    { value: 83, label: '桜木町', area: 32 },
    { value: 84, label: '関内', area: 32 },
    { value: 85, label: '元町', area: 32 },
    { value: 86, label: '中華街', area: 32 },
    { value: 87, label: '新横浜', area: 33 },
    { value: 88, label: 'センター南', area: 33 },
    { value: 89, label: '武蔵小杉', area: 34 },
    { value: 90, label: '日吉', area: 34 },
    { value: 91, label: '綱島', area: 34 },
    { value: 92, label: '溝の口', area: 35 },
    { value: 93, label: 'たまプラーザ', area: 35 },
    { value: 94, label: '青葉台', area: 35 },
    { value: 95, label: '長津田', area: 35 },
    { value: 96, label: '登戸', area: 36 },
    { value: 97, label: '新百合ヶ丘', area: 36 },
    { value: 98, label: '厚木', area: 37 },
    { value: 99, label: '海老名', area: 37 },
    { value: 100, label: '大和', area: 37 },
    { value: 101, label: '相模大野', area: 37 },
    { value: 102, label: '中央林間', area: 37 },
    { value: 103, label: '保土ヶ谷', area: 38 },
    { value: 104, label: '戸塚', area: 38 },
    { value: 105, label: '上大岡', area: 38 },
    { value: 106, label: '磯子', area: 38 },
    { value: 107, label: '金沢文庫', area: 38 },
    { value: 108, label: '横須賀', area: 39 },
    { value: 109, label: '三浦半島', area: 39 },
    { value: 110, label: '逗子', area: 39 },
    { value: 111, label: '葉山', area: 39 },
    { value: 112, label: '大船', area: 40 },
    { value: 113, label: '鎌倉', area: 40 },
    { value: 114, label: '藤沢', area: 41 },
    { value: 115, label: '茅ヶ崎', area: 41 },
    { value: 116, label: '平塚', area: 41 },
    { value: 117, label: '小田原', area: 42 },
    { value: 118, label: '箱根', area: 42 },
    { value: 119, label: '湯河原', area: 42 },
    { value: 122, label: '船橋', area: 43 },
    { value: 123, label: '津田沼', area: 43 },
    { value: 124, label: '市川', area: 43 },
    { value: 125, label: '舞浜', area: 44 },
    { value: 126, label: '浦安', area: 44 },
    { value: 127, label: '行徳', area: 44 },
    { value: 128, label: '柏', area: 45 },
    { value: 129, label: '松戸', area: 45 },
    { value: 130, label: '我孫子', area: 45 },
    { value: 131, label: '成田', area: 46 },
    { value: 132, label: '八千代', area: 46 },
    { value: 133, label: '鎌ヶ谷', area: 46 },
    { value: 134, label: '市原', area: 47 },
    { value: 135, label: '木更津', area: 47 },
    { value: 136, label: '房総', area: 47 },
    { value: 137, label: '銚子', area: 47 },

    { value: 139, label: '浦和', area: 48 },
    { value: 140, label: '川口', area: 49 },
    { value: 141, label: '越谷', area: 49 },
    { value: 142, label: '草加', area: 49 },
    { value: 143, label: '春日部', area: 49 },
    { value: 144, label: '川越', area: 50 },
    { value: 145, label: '和光', area: 50 },
    { value: 146, label: '朝霞', area: 50 },
    { value: 147, label: '志木', area: 50 },
    { value: 148, label: '所沢', area: 51 },
    { value: 149, label: '入間', area: 51 },
    { value: 150, label: '飯能', area: 51 },
    { value: 151, label: '秩父', area: 51 },
    { value: 152, label: '上尾', area: 52 },
    { value: 153, label: '久喜', area: 52 },
    { value: 154, label: '熊谷', area: 52 },
    { value: 155, label: '桶川', area: 52 },
];

const SIMPLE_SEARCH_SHOP_AREA = [
    { value: '', label: '----関東----' },
    { value: 'tokyo', label: '　東京都' },
    { value: 'kanagawa', label: '　神奈川県' },
    { value: 'chiba', label: '　千葉県' },
    { value: 'saitama', label: '　埼玉県' },
    { value: 'ibaraki', label: '　茨城県' },
    { value: 'gunma', label: '　群馬県' },
    { value: 'osaka', label: '関西' },
    { value: 'aichi', label: '東海' },
    { value: 'hokkaido', label: '北海道' },
    { value: 'miyagi', label: '東北' },
    { value: 'ishikawa', label: '甲信越・北陸' },
    { value: 'ehime', label: '中国・四国' },
    { value: 'fukuoka', label: '九州' },
];

var MARUNAGE_CATEGORY = [
    { value:1, label: '懇親会'},
    { value:2, label: '忘年会・新年会'},
    { value:3, label: '歓送迎会'},
    { value:4, label: '季節の行事'},
    { value:5, label: '表彰式'},
    { value:6, label: '内定式／入社式'},
    { value:7, label: '式典'},
    { value:8, label: '同窓会／OB会'},
    { value:9, label: '謝恩会'},
    { value:10, label: '会議・研修'},
    { value:11, label: '展示会'},
    { value:12, label: '株主総会'},
    { value:13, label: 'その他'},

];

var MARUNAGE_PEOPLE = [
    { value: '20-29', label: '20人〜29人'},
    { value: '30-39', label: '30人〜39人'},
    { value: '40-49', label: '40人〜49人'},
    { value: '50-59', label: '50人〜59人'},
    { value: '60-69', label: '60人〜69人'},
    { value: '70-79', label: '70人〜79人'},
    { value: '80-89', label: '80人〜89人'},
    { value: '90-99', label: '90人〜99人'},
    { value: '100-109', label: '100人〜109人'},
    { value: '110-119', label: '110人〜119人'},
    { value: '120-129', label: '120人〜129人'},
    { value: '130-139', label: '130人〜139人'},
    { value: '140-149', label: '140人〜149人'},
    { value: '150-159', label: '150人〜159人'},
    { value: '160-169', label: '160人〜169人'},
    { value: '170-179', label: '170人〜179人'},
    { value: '180-189', label: '180人〜189人'},
    { value: '190-199', label: '190人〜199人'},
    { value: '200-',    label:'200人〜'},
];

const MARUNAGE_CHAT_PEOPLE = [
    { value: 20, label: '20人'},
    { value: 30, label: '30人'},
    { value: 40, label: '40人'},
    { value: 50, label: '50人'},
    { value: 60, label: '60人'},
    { value: 70, label: '70人'},
    { value: 80, label: '80人'},
    { value: 90, label: '90人'},
    { value: 100, label: '100人'},
    { value: 110, label: '110人'},
    { value: 120, label: '120人'},
    { value: 130, label: '130人'},
    { value: 140, label: '140人'},
    { value: 150, label: '150人'},
    { value: 160, label: '160人'},
    { value: 170, label: '170人'},
    { value: 180, label: '180人'},
    { value: 190, label: '190人'},
    { value: 200, label: '200人'},
]

var MARUNAGE_PRICE = [
    { value: 3000, label: '〜3,000円'},
    { value: 4000, label: '〜4,000円'},
    { value: 5000, label: '〜5,000円'},
    { value: 6000, label: '〜6,000円'},
    { value: 7000, label: '〜7,000円'},
    { value: 8000, label: '〜8,000円'},
    { value: 9000, label: '〜9,000円'},
    { value: 10000, label: '〜10,000円'},
    { value: 10001, label: '10,000円〜'},
];
var MARUNAGE_SEAT_PREFERENCE = [
    { value: 1, label: '立食希望'},
    { value: 2, label: '着席希望'},
];

var MARUNAGE_MEETING_ROOM = [
    { value: 1, label: '利用なし'},
    { value: 2, label: '利用あり'},
];

var MARUNAGE_FACILITY = [
    { value: 'マイク・音響', label: 'マイク・音響'},
    { value: 'スクリーン・プロジェクター', label: 'スクリーン・プロジェクター'},
    { value: 'その他'   , label: 'その他'},
];
    
var MARUNAGE_EVENT_TIME = [
    { value: '17:00', label: '17:00'},
    { value: '17:30', label: '17:30'},
    { value: '18:00', label: '18:00'},
    { value: '18:30', label: '18:30'},
    { value: '19:00', label: '19:00'},
    { value: '19:30', label: '19:30'},
    { value: '20:00', label: '20:00'},
    { value: '20:30', label: '20:30'},
    { value: '21:00', label: '21:00'},
    { value: '21:30', label: '21:30'},
    { value: '22:00', label: '22:00'},
    { value: '', label: '-----'},
    { value: '11:00', label: '11:00'},
    { value: '11:30', label: '11:30'},
    { value: '12:00', label: '12:00'},
    { value: '12:30', label: '12:30'},
    { value: '13:00', label: '13:00'},
    { value: '13:30', label: '13:30'},
    { value: '14:00', label: '14:00'},
    { value: '14:30', label: '14:30'},
    { value: '15:00', label: '15:00'},
    { value: '15:30', label: '15:30'},
    { value: '16:00', label: '16:00'},
    { value: '16:30', label: '16:30'},
];

var MARUNAGE_STATUS = [
    { value: 'active', label: '要対応'},
    { value: 'concierge', label: '対応中'},
    { value: 'done', label: '対応済'},
    { value: 'reserved', label: '予約成立'},
    { value: 'commited', label: '実施済'},
    { value: 'closed', label: 'クローズ'},
];

var MARUNAGE_SHOP_STATUS = [
    { value: 'none', label: ''},
    { value: 'requested', label: '会場からの連絡待ち'},
    { value: 'ng', label: '空きなし'},
    { value: 'active', label: 'チャット中'},
    { value: 'reserved', label: '予約確定'},
    { value: 'closed', label: '実施済み'},
    { value: 'canceled', label: 'キャンセル済み'},
];

var SHOP_RANK = [
    { label: 'A', value: 'A'},
    { label: 'B', value: 'B'},
    { label: 'C', value: 'C'},
    { label: 'D(非契約)', value: 'D'},
];

var SHOP_GENRE = [
    { label: '居酒屋', value: 1 },
    { label: '日本料理・郷土料理', value: 2 },
    { label: '和・洋・中', value: 3 },
    { label: 'すし・魚料理・シーフード', value: 4 },
    { label: '焼肉・ホルモン', value: 5 },
    { label: '焼き鳥・肉料理・串料理', value: 6 },
    { label: '和食', value: 7 },
    { label: '中華', value: 8 },
    { label: 'イタリアン・フレンチ', value: 9 },
    { label: '欧米・各国料理', value: 10 },
    { label: 'アジア・エスニック', value: 11},
    { label: '創作料理・オーガニック', value: 12 },
    { label: 'ダイニングバー・カフェ・バー', value: 13 },
    { label: '宴会・カラオケ・エンターテイメント', value: 14 },
    { label: 'その他の料理', value: 15 },
];

var SHOP_TYPE = [
    { label: '居酒屋', value: 1 },
    { label: 'レストラン・ダイニング・カフェ', value: 3 },
    { label: 'ホテル', value: 4 },
    { label: 'パーティースペース・クラブ', value: 5 },
    { label: '結婚式場（ウェディング会場）', value: 6, disabled: true },
    { label: 'ゲストハウス・式場・宴会場', value: 7 },
    { label: 'クラブ', value: 8, disabled: true },
    { label: '会議室・イベントホール', value: 9 },
    { label: 'その他会場（クルーズ船等）', value: 10 },
];

var ROOM_TYPE = [
    { label: '個室', value: 1 },
    { label: 'フロア貸切', value: 2 },
    { label: 'オープンスペース', value: 3 },
];

var PRIVATE_ROOM_TYPE = [
    { label: '完全個室', value: 1 },
    { label: '半個室', value: 2 },
    { label: '貸切会場', value: 3 }
];

var SEAT_TYPE = [
    { label: 'テーブル', value: 1 },
    { label: 'お座敷', value: 2 },
    { label: '掘りごたつ', value: 3 },
    { label: '和室', value: 4 },
    { label: '洋室', value: 5 },
    { label: 'ソファー・その他', value: 9 },
];

var SHOP_DRINK_TYPE = [
    { label: '飲み放題付き', value: 1 },
    { label: 'プレミアム飲み放題付き', value: 2 },
    { label: 'なし', value: 3 },
];

var CREDIT_CARD = [
    { label: 'VISA', value: 1 }, 
    { label: 'MasterCard', value: 2 }, 
    { label: 'UC', value: 3 }, 
    { label: 'アメリカン・エキスプレス', value: 4 }, 
    { label: 'ダイナースクラブ', value: 5 }, 
    { label: 'JCB', value: 6 }, 
    { label: 'NICOS', value: 7 }, 
    { label: 'セゾン', value: 8 }, 
    { label: 'MUFG', value: 9 }, 
    { label: 'DC', value: 10 }, 
    { label: 'アプラス', value: 11 },
];

var PAYMENT = [
    { label: '現金のみ', value: 1 },
    { label: 'クレジット可', value: 2 },
    { label: '請求書払応相談', value: 3 },
];

var FACILITY = [
    { label: 'マイク設備', value: 1, placeholder: 'マイクスタンドあり／2本／無料、ワイヤレスマイク4本、ピンマイク2本／各1,100円' },
    { label: 'プロジェクター', value: 2, placeholder: 'あり／1台／5,000ルーメン／11,000円' },
    { label: 'スクリーン', value: 3, placeholder: 'あり／120インチ／11,000円' },
    { label: 'カラオケ設備', value: 4, placeholder: 'あり／DAM／利用料11,000円' },
    { label: '音響設備', value: 5, placeholder: 'あり／利用料11,000円' },
    { label: 'ステージ', value: 6, placeholder: 'あり／幅4m×奥行2m×高さ40cm／無料' },
    { label: '楽器演奏可', value: 7, placeholder: '可／21時まで。ドラム・大音量演奏は要事前相談' },
    { label: '照明設備', value: 8, placeholder: 'あり／利用料11,000円' },
    { label: 'DJブース', value: 9, placeholder: 'あり／機材持ち込み可。21時まで利用可能' },
    { label: 'ピアノ', value: 10, placeholder: 'グランドピアノあり／利用料22,000円' },
    { label: 'シミュレーションゴルフ', value: 11, placeholder: 'あり／利用料5,000円' },
    { label: 'ダーツ', value: 12, placeholder: 'あり／利用料5,000円' },
    { label: 'ライブ・ショー鑑賞', value: 13, placeholder: '手配可／30,000円' },
    { label: 'スポーツ観戦', value: 14, placeholder: '可／無償' },
    { label: 'クローク', value: 15, placeholder: 'あり／100名程度まで対応可能／無料' },
    { label: '控室・更衣室', value: 16, placeholder: '控室2室あり／1室11,000円' },
    { label: '車いす・バリアフリー対応', value: 17, placeholder: '可／入口から会場まで段差なし' },
    { label: 'ケーキ', value: 18, placeholder: '提供可／5,000円〜' },
    { label: 'デザートプレート', value: 19, placeholder: '提供可／5,000円〜' },
    { label: '花束', value: 20, placeholder: '提供可／5,000円〜' },
    { label: 'キッズメニュー', value: 21, placeholder: '対応可／有償' },
    { label: 'チャイルドシート', value: 22, placeholder: '貸出可／3,000円' },
    { label: 'プレイルーム', value: 23, placeholder: '利用可／30,000円〜' },
    { label: 'ホワイトボード', value: 24, placeholder: '貸出可／1枚／3,000円' },
    { label: '演台', value: 25, placeholder: '貸出可／無償' },
    { label: 'wi-fi', value: 26, placeholder: '利用可／無償' },
    { label: 'その他', value: 99, placeholder: 'その他ご要望あればご相談ください' },
];

var ADDITIONAL_CONDITION = [
    { label: '駐車場', value: 1, placeholder: 'あり／30台／宴会利用者は3時間無料' },
    { label: '送迎バス', value: 2, placeholder: '手配可／東京駅から往復／28名乗り・55,000円〜' },
    { label: '駅5分以内・雨に濡れずにアクセス可能', value: 3, placeholder: 'はい／東京駅丸の内南口から徒歩3分／地下通路からホテル入口まで直結' },
    { label: '車いす・バリアフリー対応', value: 4, placeholder: '可／入口から会場まで段差なし' },
    { label: '多目的トイレ', value: 5, placeholder: 'あり／会場と同じ3階に1か所' },
    { label: 'エレベーター', value: 6, placeholder: 'あり／2基' },
    { label: '子どもの利用可否・子ども料金', value: 7, placeholder: '可／年齢制限なし／小学生3,300円、未就学児無料' },
    { label: '料理・食品の持ち込み', value: 8, placeholder: 'ケーキのみ可／持込料3,300円。一般食品は不可' },
    { label: 'ドリンクの持ち込み', value: 9, placeholder: '可／ワイン1本につき2,200円' },
    { label: 'ドリンク銘柄の指定', value: 10, placeholder: '可／ビールはアサヒ・キリンから選択可能' },
    { label: 'アレルギー対応', value: 11, placeholder: '可／7日前までに対象食材・人数をご連絡ください' },
    { label: 'ベジタリアン対応', value: 12, placeholder: '可／個別メニューで対応。7日前までに要予約' },
    { label: 'ハラル・宗教上の食事対応', value: 13, placeholder: '一部可／豚肉・アルコール除去メニュー対応可。ハラル認証なし' },
    { label: 'オリジナルメニューの相談', value: 14, placeholder: '可／社名・イベントテーマに合わせたデザート等を相談可能' },
    { label: '請求書払い', value: 15, placeholder: '可／法人のみ。開催後に請求書発行、翌月末払い' },
    { label: '請求書の分割発行', value: 16, placeholder: '可／部署別など最大3枚まで分割可能' },
    { label: 'クレジットカード払い', value: 17, placeholder: '可／VISA・Mastercard・JCB・AMEX' },
    { label: '領収書発行', value: 18, placeholder: '可／宛名・但し書きの指定可能' },
    { label: 'キャンセル料・キャンセル規定', value: 19, placeholder: '30日前〜20％、14日前〜50％、7日前〜100％' },
    { label: '宴会時間の延長', value: 20, placeholder: '可／30分33,000円。後続予約がない場合に限る' },
    { label: 'マイクスタンド', value: 21, placeholder: 'あり／2本／無料' },
    { label: 'ワイヤレス・ピンマイク等', value: 22, placeholder: 'ワイヤレスマイク4本、ピンマイク2本／各1,100円' },
    { label: 'プロジェクター', value: 23, placeholder: 'あり／1台／5,000ルーメン／11,000円' },
    { label: 'スクリーン', value: 24, placeholder: 'あり／120インチ／11,000円' },
    { label: 'HDMI・接続ケーブル', value: 25, placeholder: 'HDMIケーブルあり／5m・10m各1本／無料' },
    { label: 'PC・スマホ接続用変換アダプター', value: 26, placeholder: 'HDMI→USB Type-C変換あり／無料' },
    { label: '楽器演奏・大音量の利用可否', value: 27, placeholder: '可／21時まで。ドラム・大音量演奏は要事前相談' },
    { label: 'ステージ', value: 28, placeholder: 'あり／幅4m×奥行2m×高さ40cm／無料' },
    { label: 'DJブース', value: 29, placeholder: 'あり／機材持ち込み可。21時まで利用可能' },
    { label: 'ピアノ', value: 30, placeholder: 'グランドピアノあり／利用料22,000円' },
    { label: '円卓の利用可否', value: 31, placeholder: '可／最大15卓・1卓8名' },
    { label: '会場内の窓', value: 32, placeholder: 'あり／会場南側全面に窓あり' },
    { label: '天井の高さ', value: 33, placeholder: '4.2m' },
    { label: '会場内の柱（視界への影響）', value: 34, placeholder: '柱2本あり／後方にあるためステージ・スクリーンへの視界に影響なし' },
    { label: '地下会場', value: 35, placeholder: 'はい／地下1階' },
    { label: 'テラスの有無', value: 36, placeholder: 'あり／歓談スペースとして利用可。雨天時利用不可' },
    { label: '眺望・夜景', value: 37, placeholder: 'あり／東京駅方面の夜景を一望できます' },
    { label: '外国語メニュー対応', value: 38, placeholder: '可／英語・中国語メニューあり' },
    { label: '外国語対応スタッフ', value: 39, placeholder: 'あり／英語対応可能なスタッフ常駐' },
    { label: 'オンラインでの事前打ち合わせ・会場下見', value: 40, placeholder: 'オンライン下見可／Zoomでスタッフが会場をご案内' },
    { label: '事前見積書の発行', value: 41, placeholder: '可／問い合わせ後、通常1営業日以内に発行' },
    { label: '事前の荷物預かり', value: 42, placeholder: '可／開催日の3日前から。段ボール5箱程度まで無料' },
    { label: 'コート・手荷物預かり（クローク）', value: 43, placeholder: 'あり／100名程度まで対応可能／無料' },
    { label: '控室・更衣室', value: 44, placeholder: '控室2室あり／1室11,000円' },
    { label: '出演者・余興の手配', value: 45, placeholder: '可／芸人・マジシャン・演奏者など手配可能' },
    { label: '司会者の手配', value: 46, placeholder: '可／プロ司会者1名55,000円〜' },
    { label: 'イベント・演出の手配', value: 47, placeholder: '可／鏡開き・餅つき・抽選会など対応可能' },
    { label: '案内看板・ウェルカムボード', value: 48, placeholder: '可／A1サイズ案内看板1枚無料' },
    { label: 'カラオケ設備', value: 49, placeholder: 'あり／DAM／利用料11,000円' },
    { label: '横断幕・大型看板の設置', value: 50, placeholder: '可／幅5m×高さ1mまで。壁面への直接貼付不可' },
    { label: '24時間利用', value: 51, placeholder: '不可／利用可能時間7:00〜23:00' },
    { label: '深夜・早朝利用', value: 52, placeholder: '可／6:00〜9:00、22:00〜24:00。追加料金あり' },
    { label: '喫煙所', value: 53, placeholder: 'あり／同フロアに屋内喫煙室あり' },
    { label: 'ペット同伴可否', value: 54, placeholder: '不可／盲導犬・介助犬・聴導犬は入館可能' },
];

var SMOKING = [
    { label: '完全禁煙', value: 1 },
    { label: '分煙', value: 2 },
    { label: '全面喫煙可', value: 3 },
    { label: 'その他', value: 9 },
];

var PLAN_TYPE_TO_VALUE = {
    course: 'course',
    meeting: 'meeting',
    lodgeMeeting: 'lodge'
}


var SHOP_PREFECTURE = [
    { value: 'hokkaido', label: '北海道' },
    { value: 'aomori', label: '青森県' },
    { value: 'iwate', label: '岩手県' },
    { value: 'miyagi', label: '宮城県' },
    { value: 'akita', label: '秋田県' },
    { value: 'yamagata', label: '山形県' },
    { value: 'fukushima', label: '福島県' },
    { value: 'ibaraki', label: '茨城県' },
    { value: 'tochigi', label: '栃木県' },
    { value: 'gunma', label: '群馬県' },
    { value: 'saitama', label: '埼玉県' },
    { value: 'chiba', label: '千葉県' },
    { value: 'tokyo', label: '東京都' },
    { value: 'kanagawa', label: '神奈川県' },
    { value: 'niigata', label: '新潟県' },
    { value: 'toyama', label: '富山県' },
    { value: 'ishikawa', label: '石川県' },
    { value: 'fukui', label: '福井県' },
    { value: 'yamanashi', label: '山梨県' },
    { value: 'nagano', label: '長野県' },
    { value: 'gifu', label: '岐阜県' },
    { value: 'shizuoka', label: '静岡県' },
    { value: 'aichi', label: '愛知県' },
    { value: 'mie', label: '三重県' },
    { value: 'shiga', label: '滋賀県' },
    { value: 'kyoto', label: '京都府' },
    { value: 'osaka', label: '大阪府' },
    { value: 'hyogo', label: '兵庫県' },
    { value: 'nara', label: '奈良県' },
    { value: 'wakayama', label: '和歌山県' },
    { value: 'tottori', label: '鳥取県' },
    { value: 'shimane', label: '島根県' },
    { value: 'okayama', label: '岡山県' },
    { value: 'hiroshima', label: '広島県' },
    { value: 'yamaguchi', label: '山口県' },
    { value: 'tokushima', label: '徳島県' },
    { value: 'kagawa', label: '香川県' },
    { value: 'ehime', label: '愛媛県' },
    { value: 'kochi', label: '高知県' },
    { value: 'fukuoka', label: '福岡県' },
    { value: 'saga', label: '佐賀県' },
    { value: 'nagasaki', label: '長崎県' },
    { value: 'kumamoto', label: '熊本県' },
    { value: 'oita', label: '大分県' },
    { value: 'miyazaki', label: '宮崎県' },
    { value: 'kagoshima', label: '鹿児島県' },
    { value: 'okinawa', label: '沖縄県' },
];

var SHOP_PEOPLE = [
    { value: 5, label: '5人' },
    { value: 10, label: '10人' },
    { value: 20, label: '20人' },
    { value: 30, label: '30人' },
    { value: 40, label: '40人' },
    { value: 50, label: '50人' },
    { value: 60, label: '60人' },
    { value: 70, label: '70人' },
    { value: 80, label: '80人' },
    { value: 90, label: '90人' },
    { value: 100, label: '100人' },
    { value: 110, label: '110人' },
    { value: 120, label: '120人' },
    { value: 130, label: '130人' },
    { value: 140, label: '140人' },
    { value: 150, label: '150人' },
    { value: 160, label: '160人' },
    { value: 170, label: '170人' },
    { value: 180, label: '180人' },
    { value: 190, label: '190人' },
    { value: 200, label: '200人' },
    { value: 300, label: '300人' },
    { value: 400, label: '400人' },
    { value: 500, label: '500人' },
    { value: 600, label: '600人' },
    { value: 700, label: '700人' },
    { value: 800, label: '800人' },
    { value: 900, label: '900人' },
    { value: 1000, label: '1000人' }
];

const SHOP_REVIEW_AGE = [
    { value: 10, label: '10代' },
    { value: 20, label: '20代' },
    { value: 30, label: '30代' },
    { value: 40, label: '40代' },
    { value: 50, label: '50代' },
    { value: 60, label: '60代' },
    { value: 70, label: '70代' },
    { value: 80, label: '80代' },
    { value: 90, label: '90代' },
    { value: 100, label: '100代' },
];

export default {
    CONCIERGE_MEMBERS: CONCIERGE_MEMBERS,
    MARUNAGE_SHOP_PREFECTURE: MARUNAGE_SHOP_PREFECTURE,
    MARUNAGE_SHOP_AREA: MARUNAGE_SHOP_AREA,
    MARUNAGE_CATEGORY:MARUNAGE_CATEGORY,
    MARUNAGE_PEOPLE: MARUNAGE_PEOPLE,
    MARUNAGE_PRICE: MARUNAGE_PRICE,
    MARUNAGE_SEAT_PREFERENCE: MARUNAGE_SEAT_PREFERENCE,
    MARUNAGE_MEETING_ROOM: MARUNAGE_MEETING_ROOM,
    MARUNAGE_FACILITY: MARUNAGE_FACILITY,
    MARUNAGE_EVENT_TIME: MARUNAGE_EVENT_TIME,
    MARUNAGE_STATUS: MARUNAGE_STATUS,
    MARUNAGE_SHOP_STATUS: MARUNAGE_SHOP_STATUS,
    MARUNAGE_CHAT_PEOPLE: MARUNAGE_CHAT_PEOPLE,
    SHOP_TAGS: SHOP_TAGS,
    SHOP_SCENES: SHOP_SCENES,
    SHOP_FEATURES: SHOP_FEATURES,
    SHOP_AREA: SHOP_AREA,
    SHOP_AREA_DETAIL: SHOP_AREA_DETAIL,
    SHOP_RANK: SHOP_RANK,
    SHOP_GENRE: SHOP_GENRE,
    SHOP_TYPE: SHOP_TYPE,
    SHOP_DRINK_TYPE:SHOP_DRINK_TYPE,
    ROOM_TYPE: ROOM_TYPE,
    PRIVATE_ROOM_TYPE: PRIVATE_ROOM_TYPE,
    SEAT_TYPE: SEAT_TYPE,
    CREDIT_CARD: CREDIT_CARD,
    PAYMENT: PAYMENT,
    FACILITY: FACILITY,
    ADDITIONAL_CONDITION: ADDITIONAL_CONDITION,
    SMOKING: SMOKING,
    PLAN_TYPE_TO_VALUE: PLAN_TYPE_TO_VALUE,
    SHOP_PREFECTURE: SHOP_PREFECTURE,
    SHOP_PEOPLE: SHOP_PEOPLE,
    SIMPLE_SEARCH_SHOP_AREA: SIMPLE_SEARCH_SHOP_AREA,
    SHOP_REVIEW_AGE: SHOP_REVIEW_AGE,
};
